import React from "react"
import { ArrowRight, Clock } from "lucide-react"
import { useLang } from "./i18n/LangContext"
import { useWaitlistModal } from "./WaitlistModalContext"

export function FinalCta() {
  const { t } = useLang()
  const { openModal } = useWaitlistModal()

  return (
    <section className="bg-brand-600 dark:bg-brand-700 py-20 sm:py-28">
      <div className="mx-auto max-w-2xl px-4 sm:px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white text-balance">
          {t.cta.heading}
        </h2>
        <p className="mt-4 text-brand-200">{t.cta.subheading}</p>

        <div className="mt-8 flex flex-col items-center gap-3">
          <button
            type="button"
            onClick={() => openModal("final_cta")}
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-white px-6 py-3.5 text-sm sm:text-base font-semibold text-brand-700 hover:bg-brand-50 active:scale-95 transition-all"
          >
            {t.cta.cta} <ArrowRight className="h-4 w-4" />
          </button>
          <p className="flex items-center justify-center gap-1.5 text-xs text-brand-300">
            <Clock className="h-3 w-3" />
            {t.cta.hint}
          </p>
        </div>
      </div>
    </section>
  )
}
